<template>
  <!-- 编辑模态框 -->
  <el-dialog :title="titleLabel[dialogStatus] + '邮件联系信息'" :visible.sync="dialogVisible" top="20px" width="620px">
    <el-form :rules="rules" ref="dataForm" :model="fd" label-position="left" label-width="80px">
      <!-- 邮件类型 -->
      <el-form-item label="邮件类型" prop="type">
        <el-select v-if="dialogStatus === 'action.create'" v-model="fd.type" placeholder="请选择邮件类型">
          <el-option
              v-for="item in contactTypeList"
              :key="item.code"
              :label="item.value"
              :value="item.code">
          </el-option>
        </el-select>
        <span class="badge" :class="{'badge-success': fd.type === 'inquery', 'badge-info': fd.type === 'issue'}"
              v-else-if="dialogStatus === 'action.edit'">{{ fd.type_name }}</span>
      </el-form-item>
      <!-- 称呼 -->
      <el-form-item label="称呼" prop="solutation">
        <el-input type="textarea" v-model="fd.solutation" :autosize="{minRows: 2, maxRows: 8}"
                  placeholder="请输入称呼"></el-input>
      </el-form-item>
      <!-- 收件人 -->
      <el-form-item label="收件人" prop="recipient">
        <el-input type="textarea" v-model="fd.recipient" :autosize="{minRows: 4, maxRows: 8}"
                  placeholder="请输入收件人，一个一行"></el-input>
      </el-form-item>
      <!-- 抄送人 -->
      <el-form-item label="抄送人" prop="copy">
        <el-input type="textarea" v-model="fd.copy" :autosize="{minRows: 4, maxRows: 8}"
                  placeholder="请输入抄送人，一个一行"></el-input>
      </el-form-item>
      <el-form-item>
        <div style="float: right;">
          <el-button size="small" @click="cancelData">取消</el-button>
          <el-button size="small"
                     v-if="dialogStatus==='action.create' && $perm(['company.change_insurance_company'])"
                     type="primary" @click="createData">确定
          </el-button>
          <el-button size="small"
                     v-if="dialogStatus==='action.edit' && $perm(['company.change_insurance_company'])"
                     type="primary" @click="updateData">确定
          </el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
  import {createContact, fetchContact, updateContact} from '@/api/insurance_company'

  export default {
    name: 'contact-dialog',
    props: {
      companyId: {
        type: Number,
        required: true
      },
      contactTypeList: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        dialogVisible: false,
        titleLabel: {
          'action.create': '新增',
          'action.edit': '编辑'
        },
        dialogStatus: '',
        fd: {},
        rules: {
          type: [{required: true, message: '请选择邮件类型', trigger: 'blur'}],
          recipient: [{required: true, message: '请输入收件人邮箱', trigger: 'blur'}]
        }
      }
    },
    methods: {
      resetFD() {
        this.fd = {}
      },
      handleCreate() {
        this.dialogStatus = 'action.create'
        this.dialogVisible = true
      },
      handleUpdate(id) {
        this.dialogStatus = 'action.edit'
        fetchContact(id)
          .then(res => {
            this.fd = Object.assign({}, res)
            this.dialogVisible = true

            this.$nextTick(() => {
              this.$refs['dataForm'].clearValidate()
            })
          })
          .catch(error => {
            this.$error_message(error)
          })
      },
      createData() {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.fd.insurance_company = this.companyId
            createContact(this.fd)
              .then(res => {
                this.$message.success(`创建邮件联系信息成功, id=${res.id}`)

                this.$nextTick(() => {
                  this.$refs['dataForm'].resetFields()
                  this.$refs['dataForm'].clearValidate()
                  this.dialogVisible = false
                  this.resetFD()
                  this.$emit('updateList')
                })
              })
              .catch(error => {
                this.$error_message(error)
              })
          }
        })
      },
      updateData() {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            updateContact(this.fd.id, this.fd)
              .then(() => {
                this.$message.success('更新邮件联系信息成功')

                this.$nextTick(() => {
                  this.$refs['dataForm'].resetFields()
                  this.$refs['dataForm'].clearValidate()
                  this.dialogVisible = false
                  this.resetFD()
                  this.$emit('updateList')
                })
              })
              .catch(error => {
                this.$error_message(error)
              })
          }
        })
      },
      // 取消修改
      cancelData() {
        this.resetFD()
        this.dialogVisible = false
        this.$nextTick(() => {
          this.$refs.dataForm.resetFields()
          this.$refs.dataForm.clearValidate()
        })
      }
    }
  }
</script>
